import React, { useState } from 'react'
import parentinfoStyle from './parentsInfo.module.css'
require('typeface-poppins')

export default function ParentsInfo() {

    const [openIndex, setOpenIndex] = useState(null); // state to track open accordion item, null means none are open

    const handleToggle = (index) => {
        // Toggle between opening and closing the same accordion item
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <>
            <div className={`${parentinfoStyle.parentinfoAccordion} accordion mb-3`} id="ordersummaryInfo">
                <div className={`${parentinfoStyle.parentinfoMainitem} accordion-item`}>
                    <h2 className="accordion-header">
                        <button className={`${parentinfoStyle.parentinfobuttonItem} ${parentinfoStyle.parentinfoBeforebg} accordion-button ${openIndex === 0 ? '' : `${parentinfoStyle.parentinfobgColor} collapsed`}`} type="button" onClick={() => handleToggle(0)} aria-expanded={openIndex === 0 ? 'true' : 'false'} aria-controls="collapseOne">
                            Parents Information*
                        </button>
                    </h2>
                    <div id="collapseOne" className={`accordion-collapse collapse ${openIndex === 0 ? 'show' : ''}`} data-bs-parent="#ordersummaryInfo">
                        <div className={`${parentinfoStyle.parentinfoBody} accordion-body`}>
                            <div className={parentinfoStyle.parentinfoWrapper}>
                                <div className="mb-3">
                                    <input type="text" className={`${parentinfoStyle.parentinfoInput} form-control`} placeholder='*Parents First Name & Last Name' />
                                </div>
                                <div className="mb-3">
                                    <input type="email" className={`${parentinfoStyle.parentinfoInput} form-control`} placeholder='*Parents Email Address' />
                                </div>
                                <div className="mb-3">
                                    <input type="text" className={`${parentinfoStyle.parentinfoInput} form-control`} placeholder='*Parents Phone Number' />
                                </div>
                                <div>
                                    <button type="submit" className={`${parentinfoStyle.parentinfosaveBtn} btn btn-danger w-100`}>Save Info</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
